import {
  Edit,
  ListButton,
  required,
  SaveButton,
  ShowButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { RolesTableInput } from "@/inputs/RolesTableInput";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ShowButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <ShowButton />
  </TopToolbar>
);

export const GroupEdit = () => (
  <Edit actions={<EditActions />} mutationMode="pessimistic">
    <SimpleForm toolbar={<EditToolbar />}>
      <TextInput source="name" isRequired={true} validate={required()} />
      <TextInput source="description" isRequired={true} validate={required()} />
      <RolesTableInput source="roles" label="Methods list" />
    </SimpleForm>
  </Edit>
);
